import $ from 'jquery';
import { jsPDF } from 'jspdf';

/*
 * PDF Printer
 */
export class Printer {
  static fonts = {};

  constructor() {
    if ($('.summary-wrapper').length === 0) return;

    this.init();
  }

  async init() {
    await Promise.all(['DMSans-Regular', 'DMSans-Medium'].map(async (fontName) => {
      const font = await (await fetch('/wp-content/themes/valdorisk/components/Summary/fonts/' + fontName + '.b64')).text();

      Printer.fonts[fontName] = font;
    }));

    $('.btn-download-pdf').removeClass('disabled');

    $('.btn-download-pdf').on('click', (event) => {
      event.preventDefault();

      PDFPrinter.print($('.summary-wrapper'), $('.summary-wrapper').data('document-title'));
    });
  }
}

/*
 * PDF Printer
 */
class PDFPrinter {
  static debug = false;
  static hardDebug = false;
  static container
  static page
  static pdf;
  static ratio;
  static pageCount = 1;
  static currentPage = 1;
  static pageBottom = 27.7;
  static fontFactor = 1;

  static print(container, fileName) {
    PDFPrinter.container = container;
    PDFPrinter.debug = PDFPrinter.container.data('debug') === true ? true : false;
    PDFPrinter.fontFactor = PDFPrinter.container.data('font-factor') ? parseFloat(PDFPrinter.container.data('font-factor')) : 1;
    PDFPrinter.pageCount = 1;
    PDFPrinter.currentPage = 1;

    PDFPrinter.pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'cm',
      format: 'a4'
    });

    PDFPrinter.pdf.setDisplayMode('fullheight');

    PDFPrinter.addFont('DMSans-Regular');
    PDFPrinter.addFont('DMSans-Medium');
    PDFPrinter.pdf.setFont('DMSans-Regular');

    PDFPrinter.page = PDFPrinter.container;
    PDFPrinter.page.addClass('print');
    PDFPrinter.ratio = 21 / PDFPrinter.page.width();

    let pageStart = 0;
    let yReference = 0;

    PDFPrinter.countPages();
    PDFPrinter.addPageNumber();

    PDFPrinter.page.find('.export').each(function () {
      let item = $(this);

      if (PDFPrinter.isItemExcluded(item)) return;

      let x = position(item, PDFPrinter.page).x * PDFPrinter.ratio;
      let y = (position(item, PDFPrinter.page).y - yReference) * PDFPrinter.ratio;

      if (PDFPrinter.checkPageBreak(y, item, yReference)) {
        PDFPrinter.pdf.addPage('a4');
        pageStart = 2;

        yReference = position(item, PDFPrinter.page).y;
        y = (position(item, PDFPrinter.page).y - yReference) * PDFPrinter.ratio;

        PDFPrinter.currentPage++;
        PDFPrinter.addPageNumber();
      }

      if (PDFPrinter.hardDebug) PDFPrinter.addRect(x, pageStart + y, item.outerWidth() * PDFPrinter.ratio, item.outerHeight() * PDFPrinter.ratio)

      // Draw
      if (item.hasClass('export-text')) PDFPrinter.addText(item, x, pageStart + y);
      if (item.hasClass('export-image')) PDFPrinter.addImage(item, x, pageStart + y);
    });

    PDFPrinter.page.removeClass('print');

    if (PDFPrinter.debug) {
      $('#pdf-debug').get(0).src = PDFPrinter.pdf.output('datauristring');
    } else {
      PDFPrinter.pdf.save(fileName + '.pdf');
    }
  }

  static checkPageBreak(y, item, yReference) {
    return y + item.outerHeight() * PDFPrinter.ratio > PDFPrinter.pageBottom || PDFPrinter.getGroupLimt(item, yReference) > PDFPrinter.pageBottom || item.hasClass('export-page-break');
  }

  static getGroupLimt(item, yReference) {
    let group = $(item).parents('.export-group');
    return group.length > 0 ? (position(group, PDFPrinter.page).y - yReference) * PDFPrinter.ratio + group.outerHeight() * PDFPrinter.ratio : 0;
  }

  static countPages() {
    let yReference = 0;

    PDFPrinter.page.find('.export').each(function () {
      let item = $(this);

      if (PDFPrinter.isItemExcluded(item)) return;

      const y = (position(item, PDFPrinter.page).y - yReference) * PDFPrinter.ratio;

      if (PDFPrinter.checkPageBreak(y, item, yReference)) {
        yReference = position(item, PDFPrinter.page).y;

        PDFPrinter.pageCount++;
      }
    });
  }

  static addPageNumber() {
    const footerPage = PDFPrinter.container.find('.footer-page');

    PDFPrinter.addText(footerPage, 10.5, 28.25, PDFPrinter.currentPage + '/' + PDFPrinter.pageCount, 'center');
  }

  static addFont(fontName) {
    PDFPrinter.pdf.addFileToVFS(fontName + '.ttf', Printer.fonts[fontName]);
    PDFPrinter.pdf.addFont(fontName + '.ttf', fontName, 'normal');
  }

  static addLine(x, y, length, color, lineWidth) {
    length = length ? length : item.width() * PDFPrinter.ratio;

    PDFPrinter.pdf.setDrawColor(color ? color : '#ff9900');
    PDFPrinter.pdf.setLineWidth(lineWidth ? lineWidth : 0.01);
    PDFPrinter.pdf.setDrawColor(color);
    PDFPrinter.pdf.line(x, y, x + length, y);
  }

  static addRect(x, y, w, h, color, lineWidth) {
    PDFPrinter.pdf.setDrawColor(color ? color : '#ff9900');
    PDFPrinter.pdf.setLineWidth(lineWidth ? lineWidth : 0.01);
    PDFPrinter.pdf.rect(x, y, w, h);
  }

  static addFilledRect(x, y, w, h, color) {
    PDFPrinter.pdf.setFillColor(color ? color : '#ff9900');
    PDFPrinter.pdf.rect(x, y, w, h, 'F');
  }

  static addImage(item, x, y) {
    if (item.get(0).tagName == 'CANVAS') {
      PDFPrinter.pdf.addImage(item.get(0), 'png', x, y, item.width() * PDFPrinter.ratio, item.height() * PDFPrinter.ratio);
    } else if (item.get(0).tagName == 'IMG') {
      if (!PDFPrinter.debug) PDFPrinter.pdf.addImage(item.get(0), 'png', x, y, item.width() * PDFPrinter.ratio, item.height() * PDFPrinter.ratio);
    }
  }

  static addText(item, x, y, text, options) {
    const fontSize = parseFloat(item.css('font-size')) / PDFPrinter.fontFactor;
    const fontOffset = fontSize * 0.03528;
    const w = item.outerWidth() * PDFPrinter.ratio;
    const h = item.outerHeight() * PDFPrinter.ratio;

    if (item.css('font-weight') == '400') {
      PDFPrinter.pdf.setFont('DMSans-Regular');
    } else {
      PDFPrinter.pdf.setFont('DMSans-Medium');
    }

    PDFPrinter.pdf.setFontSize(fontSize);
    PDFPrinter.pdf.setLineHeightFactor(1.2);

    if (item.css('background-color') != 'rgba(0, 0, 0, 0)') {
      PDFPrinter.addFilledRect(x, y, w, h, rgb2hex(item.css('background-color')));
    }

    const padding = {
      top: parseFloat(item.css('padding-top')) * PDFPrinter.ratio,
      right: parseFloat(item.css('padding-right')) * PDFPrinter.ratio,
      bottom: parseFloat(item.css('padding-bottom')) * PDFPrinter.ratio,
      left: parseFloat(item.css('padding-left')) * PDFPrinter.ratio,
      x: parseFloat(item.css('padding-left')) * PDFPrinter.ratio + parseFloat(item.css('padding-right')) * PDFPrinter.ratio,
      y: parseFloat(item.css('padding-top')) * PDFPrinter.ratio + parseFloat(item.css('padding-bottom')) * PDFPrinter.ratio,
    }

    const wText = w - padding.x;
    const hText = h - padding.y;

    const finalText = text ? text : PDFPrinter.pdf.splitTextToSize(item.get(0).innerText, wText);
    PDFPrinter.pdf.text(finalText, x + padding.left, y + padding.top + fontOffset, options);

    if (PDFPrinter.hardDebug) PDFPrinter.addRect(x + padding.left, y + padding.top, wText, hText, '#ff0099', 0.005);
  
    if (item.hasClass('export-line-above')) PDFPrinter.addLine(x, y, w, item.css('border-top-color'));
    if (item.hasClass('export-line-below')) PDFPrinter.addLine(x, y + h, w, item.css('border-bottom-color'));
  }

  static isItemExcluded(item) {
    return (item.hasClass('print-excluded') || item.parents('.print-excluded').length > 0 || item.hasClass('d-none') || item.parents('.d-none').length > 0)
  }
}

/*
 * Get the real position (not the jQuery shity one)
 */
function position(element, target) {
  if (typeof target == 'string') target = $(target);

  const targetPosition = (target) ? { x: target.get(0).getBoundingClientRect().x, y: target.get(0).getBoundingClientRect().y } : { x: 0, y: 0 };
  const itemBoundingClientRect = element.get(0).getBoundingClientRect();
  const difference = { x: itemBoundingClientRect.x - targetPosition.x, y: itemBoundingClientRect.y - targetPosition.y }
  const pageScroll = (target) ? { x: 0, y: 0 } : { x: window.scrollX, y: window.scrollY };

  return {
    x: difference.x + pageScroll.x,
    y: difference.y + pageScroll.y
  }
}

// Convert background-color to hex
function rgb2hex(rgb) {
  if (/^#[0-9A-F]{6}$/i.test(rgb)) return rgb;

  rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);

  if (rgb == null) return "N/A";

  function hex(x) {
    return ("0" + parseInt(x).toString(16)).slice(-2);
  }

  return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
}

